module.exports = __webpack_public_path__ + "img/flatroof.6f908430.jpg";